export enum AnnouncementLevel {
  Info = 'Info',
  Advisory = 'Advisory',
  Important = 'Important',
  Critical = 'Critical'
}

export interface IAnnouncement {
  id: string;
  title: string;
  body: string;
  language: string;
  level: AnnouncementLevel;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface IAnnouncementListing {
  id: string;
  title: string;
  body: string;
  language: string;
  level: AnnouncementLevel;
  active: boolean;
  status: string;
}

export interface ICreateAnnouncementModel {
  title: string;
  body: string;
  language: string;
  level?: AnnouncementLevel | string;
}

export interface IUpdateAnnouncementModel {
  id: string;
  title?: string;
  body?: string;
  language?: string;
  level?: AnnouncementLevel | string;
}
